var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-bar mt-5"},[_c('PoweredByFoot',{attrs:{"icons":_vm.icons}}),_c('hr',{staticClass:"my-5"}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 mb-sm-0 mb-5"},[_c('FootLinks')],1),_c('div',{staticClass:"col-sm-6"},[_c('MadeByFoot')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }